import { routes, routesMap } from 'app/Router';
import { useLocation } from 'react-router';

export const usePage = () => {
  const login = routes.find((item) => item.name === 'login');
  const platform = routes.find((item) => item.name === 'platform');
  const { pathname } = useLocation();
  const isLoginPage =
    pathname.startsWith(login?.path as string) ||
    pathname.startsWith('/auth/callback');
  const isPlatformPage = pathname.startsWith(platform?.path as string);
  const isRootAddress = pathname.toString() === '/';
  const isShoppingCartPage = pathname.startsWith(
    routesMap.shoppingCart?.path as string
  );
  const isNotificationPage = pathname.startsWith(
    routesMap.notification?.path as string
  );
  const isProjectPage = pathname.startsWith(routesMap.projects?.path as string);
  const isWorkspacePage = pathname.startsWith(
    routesMap.workspace?.path as string
  );
  const isCompanyGalleryPage = pathname.startsWith(
    routesMap.companyGallery!.path
  );
  const isSsoBuyerCompanyGalleryPage = pathname.startsWith(
    routesMap.ssoBuyerCompanyGallery!.path.replace('/:id', '')
  );
  const isGalleryPage = pathname.startsWith(routesMap.gallery.path);
  const isShopPage = isGalleryPage || isCompanyGalleryPage;
  const isOrderHistoryPage = pathname.startsWith(
    routesMap.orderHistory.path as string
  );

  const isJobConfigPage = pathname.startsWith(
    routesMap.jobConfig.path as string
  );

  const isUnavailablePage = pathname.startsWith(
    routesMap.unavailable.path as string
  );

  const isJobArchivePage = pathname.startsWith(
    routesMap.jobArchive.path as string
  );

  const isFixPage =
    isGalleryPage ||
    isCompanyGalleryPage ||
    isLoginPage ||
    isShoppingCartPage ||
    isWorkspacePage ||
    isOrderHistoryPage ||
    isNotificationPage ||
    isProjectPage ||
    isJobArchivePage;

  return {
    isLoginPage,
    isPlatformPage,
    isRootAddress,
    isFixPage,
    isGalleryPage,
    isCompanyGalleryPage,
    isShopPage,
    isShoppingCartPage,
    isWorkspacePage,
    isOrderHistoryPage,
    isJobConfigPage,
    isNotificationPage,
    isUnavailablePage,
    isProjectPage,
    isJobArchivePage,
    isSsoBuyerCompanyGalleryPage,
  };
};
